module.exports = __webpack_public_path__ + "img/mark_as_paid.252ce63a.svg";